import React from 'react';

interface SidebarLogoProps {
    isOpen: boolean;
}

/** Logos da marca — apenas desktop (tokens via classes Tailwind existentes). */
export function SidebarLogo({ isOpen }: SidebarLogoProps) {
    return (
        <div
            className={`hidden shrink-0 md:mb-8 md:flex ${isOpen ? 'w-full items-center justify-start gap-3 rounded-b-2xl px-6 py-4' : 'justify-center p-2'}`}
        >
            {isOpen ? (
                <>
                    <img src="/logo%20principal%20140x40.png" alt="Adlitics" className="h-8 w-auto object-contain dark:hidden" />
                    <img
                        src="/logo%20principal%20dark%20140x40.png"
                        alt="Adlitics"
                        className="hidden h-8 w-auto object-contain dark:block"
                    />
                </>
            ) : (
                <>
                    <img src="/colpasado%2048x48.png" alt="Adlitics" className="h-8 w-8 object-contain dark:hidden" />
                    <img src="/colpasado%20dark%2048x48.png" alt="Adlitics" className="hidden h-8 w-8 object-contain dark:block" />
                </>
            )}
        </div>
    );
}
